import styled from '@emotion/styled'
import { width } from '@fortawesome/free-solid-svg-icons/faInfo'
import { Box, Button, Container, Input } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
const useStyles = styled((theme) => ({
  InPut: {
    color: 'white',
    borderRadius: '5px',
    background: '#545454',
    padding: '2px 10px',
    width: '230px',
    '--Input-focusedInset': '#86b7fe',
    '--Input-focusedThickness': '0.25rem',
    '--Input-focusedHighlight': 'rgba(13,110,253,.25)',

    '&::before': {
      transition: 'box-shadow .15s ease-in-out',
    },
    '&:focus-within': {
      borderColor: '#86b7fe',
    },
  },
}))
export default function QuestionAnswer({ setRevenuCheck, updatepage }) {
  let w_monbuget = localStorage.getItem('w-monbuget')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation('layout') // LAP-733 (GE022)

  const [qdate, setQDate] = useState(new Date().toISOString().slice(0, 10))
  const [anwserSum, setAnwserSum] = useState(false)
  const [anwser, setAnwser] = useState({
    a1: 0,
    a2: 40,
    a3: 10,
    a4: 15,
    a5: 15,
    a6: 20,
  })
  const handelAnwser = (e) => {
    let id = e.target.name
    if (isNumber(e.target.value)) {
      document.getElementById(id).innerHTML = ''
    } else {
      document.getElementById(id).innerHTML = t('finance.monBudget.numberOnly')
    }

    setAnwser((anwser) => ({ ...anwser, [id]: e.target.value }))
  }
  const isNumber = (str) => {
    if (str.trim() === '') {
      return false
    }

    return !isNaN(str)
  }
  const submitRevenuBudget = async () => {
    const payload = {
      date: qdate,
      value1: anwser.a1,
      value2: anwser.a2,
      value3: anwser.a3,
      value4: anwser.a4,
      value5: anwser.a5,
      value6: anwser.a6,
    }
    let sum =
      parseFloat(anwser.a2) +
      parseFloat(anwser.a3) +
      parseFloat(anwser.a4) +
      parseFloat(anwser.a5) +
      parseFloat(anwser.a6)

    // console.log(sum)
    if (sum <= 100 && sum > 0) {
      const response = await makePostRequest('/api/Finance/add-budgetrevenu/', payload, {}, true)
      if (response.status === 200) {
        if (w_monbuget) {
          await makePostRequest(
            '/api/app/user-wizard/',
            { step: w_monbuget, completed: true, skip: true },
            {},
            true,
          )

          dispatch(setUserWizardDone({ step: w_monbuget, completed: true, skip: true }))
          localStorage.removeItem('w-monbuget')
          navigate('/')
        }
        setRevenuCheck(false)
        updatepage()
      }
      // setAnwserSum(false)
    } else {
      setAnwserSum(true)
    }
  }
  const newDate = new Date()
  newDate.setFullYear(newDate.getFullYear() + 3) // Add 3 years

  const isoString = newDate.toISOString().slice(0, 10)
  const classes = useStyles()
  return (
    <Box color={'white'}>
      <Box textAlign={'center'} mt={5} sx={{ fontWeight: 700, fontSize: '20px' }}>
        {t('finance.monBudget.welcomeBudget')}
      </Box>
      <Container sx={{ mt: 3 }}>
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Box>{t('finance.monBudget.defineReferenceIncome')}</Box>
          <Box ml={'auto'} textAlign={'center'}>
            <Box
              sx={{
                '.MuiInputBase-input': {
                  width: 80,
                  marginRight: 3,
                  textAlign: 'center',
                  fontSize: 'x-large',
                },
              }}
            >
              <Input
                sx={{ color: 'white' }}
                className={classes.InPut}
                name="a1"
                value={anwser.a1}
                onChange={handelAnwser}
                type="number"
              />
              €
            </Box>
            <Box color={'red'} id="a1"></Box>
            <Box color={'gray'}>{t('finance.monBudget.referenceIncomeShort')}</Box>
          </Box>
        </Box>
        <hr />
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Box>
            {t('finance.monBudget.distribute100')}
          </Box>
        </Box>
        <hr />
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Box>
            {t('finance.monBudget.fixedNecessary')} <br />
            {t('finance.monBudget.fixedNecessaryNote')}
          </Box>
          <Box ml={'auto'} textAlign={'center'}>
            <Box
              sx={{
                '.MuiInputBase-input': {
                  width: 80,
                  marginRight: 3,
                  textAlign: 'center',
                  fontSize: 'x-large',
                },
              }}
            >
              <Input
                sx={{ color: 'white' }}
                className={classes.InPut}
                name="a2"
                value={anwser.a2}
                onChange={handelAnwser}
                type="number"
              />
              %
            </Box>
            <Box color={'red'} id="a2"></Box>
            <Box color={'gray'}>{t('finance.monBudget.fixedNecessaryShort')}</Box>
          </Box>
        </Box>
        <hr />
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Box>
            {t('finance.monBudget.variableNecessary')} <br />
            {t('finance.monBudget.variableNecessaryNote')}
          </Box>
          <Box ml={'auto'} textAlign={'center'}>
            <Box
              sx={{
                '.MuiInputBase-input': {
                  width: 80,
                  marginRight: 3,
                  textAlign: 'center',
                  fontSize: 'x-large',
                },
              }}
            >
              <Input
                sx={{ color: 'white' }}
                className={classes.InPut}
                name="a3"
                value={anwser.a3}
                onChange={handelAnwser}
                type="number"
              />
              %
            </Box>
            <Box color={'red'} id="a3"></Box>
            <Box color={'gray'}>{t('finance.monBudget.variableNecessaryShort')}</Box>
          </Box>
        </Box>
        <hr />
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Box>
            {t('finance.monBudget.fixedSecondary')} <br />
            {t('finance.monBudget.fixedSecondaryNote')}
          </Box>
          <Box ml={'auto'} textAlign={'center'}>
            <Box
              sx={{
                '.MuiInputBase-input': {
                  width: 80,
                  marginRight: 3,
                  textAlign: 'center',
                  fontSize: 'x-large',
                },
              }}
            >
              <Input
                sx={{ color: 'white' }}
                className={classes.InPut}
                name="a4"
                value={anwser.a4}
                onChange={handelAnwser}
                type="number"
              />
              %
            </Box>
            <Box color={'red'} id="a4"></Box>
            <Box color={'gray'}>{t('finance.monBudget.fixedSecondaryShort')}</Box>
          </Box>
        </Box>
        <hr />
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Box>
            {t('finance.monBudget.variableSecondary')} <br />
            {t('finance.monBudget.variableSecondaryNote')}
          </Box>
          <Box ml={'auto'} textAlign={'center'}>
            <Box
              sx={{
                '.MuiInputBase-input': {
                  width: 80,
                  marginRight: 3,
                  textAlign: 'center',
                  fontSize: 'x-large',
                },
              }}
            >
              <Input
                sx={{ color: 'white' }}
                className={classes.InPut}
                name="a5"
                value={anwser.a5}
                onChange={handelAnwser}
                type="number"
              />
              %
            </Box>
            <Box color={'red'} id="a5"></Box>
            <Box color={'gray'}>{t('finance.monBudget.variableSecondaryShort')}</Box>
          </Box>
        </Box>
        <hr />
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Box>
            {t('finance.monBudget.cashflowLabel')} <br />
            {t('finance.monBudget.cashflowNote')}
          </Box>
          <Box ml={'auto'} textAlign={'center'}>
            <Box
              sx={{
                '.MuiInputBase-input': {
                  width: 80,
                  marginRight: 3,
                  textAlign: 'center',
                  fontSize: 'x-large',
                },
              }}
            >
              <Input
                sx={{ color: 'white' }}
                className={classes.InPut}
                name="a6"
                value={anwser.a6}
                onChange={handelAnwser}
                type="number"
              />
              %
            </Box>
            <Box color={'red'} id="a6"></Box>
            <Box color={'gray'}>{t('finance.monBudget.cashflowShort')}</Box>
          </Box>
        </Box>
        <hr />
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Box>{t('finance.monBudget.objectivesEndDate')}</Box>
          <Box ml={'auto'} textAlign={'center'}>
            <Box>
              <Input
                type="date"
                sx={{ color: 'white' }}
                className={classes.InPut}
                onChange={(e) => {
                  setQDate(e.target.value)
                }}
                defaultValue={isoString}
              />
            </Box>
          </Box>
        </Box>
        <hr />
        {anwserSum && (
          <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
            <Box color={'red'}>
              {t('finance.monBudget.sumExceeds100')}
            </Box>
          </Box>
        )}

        <Box display={'flex'} justifyContent={'end'} pb={10}>
          <Button variant="contained" sx={{ mr: 5 }} onClick={submitRevenuBudget}>
            {t('finance.common.confirm')}
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              if (w_monbuget) {
                localStorage.removeItem('w-monbuget')
                navigate('/')
              }
            }}
          >
            {t('finance.common.cancel')}
          </Button>
        </Box>
      </Container>
    </Box>
  )
}
